import { TDropdownType } from '../../components/DropdownMenu/interfaces';

export const LEAD_REALTOR_EXCEPTION_SECTIONS: TDropdownType[] = ['dealRent'];
